import { hideToast } from "src/store/toast.store";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/store";
import { Toast } from "./Toast";

export const GlobalToast = () => {
  const dispatch = useAppDispatch();
  const { message, type } = useAppSelector((state) => state.toast);

  useEffect(() => {
    if (message) {
      const timeout = setTimeout(() => dispatch(hideToast()), 3500);
      return () => clearTimeout(timeout);
    }
  }, [message]);

  if (!message) return null;

  return (
    <div className="fixed top-6 right-6 z-50 animate-in slide-in-from-right-full duration-300 ease-out">
      <Toast message={message} type={type} />
    </div>
  );
};
